import { createWebHistory, createRouter } from 'vue-router'

import HomeView from '@/views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/alarms/:id?',
    name: 'alarms',
    meta: {
      breadcrumbs: [{ displayName: 'Alarm Log', displayLink: null }]
    },
    component: () => import('@/views/AlarmView.vue')
  },
  {
    path: '/performance',
    name: 'performance',
    meta: {
      breadcrumbs: [{ displayName: 'Electrical Performance', displayLink: null }]
    },
    component: () => import('@/views/ElectricalPerformanceView.vue')
  },
  {
    path: '/documentation',
    name: 'documentation',
    meta: {
      breadcrumbs: [{ displayName: 'Documentation', displayLink: null }]
    },
    component: () => import('@/views/DocumentationView.vue')
  },
  {
    path: '/survey',
    name: 'survey',
    meta: {
      breadcrumbs: [{ displayName: 'Marine Survey Data', displayLink: null }]
    },
    component: () => import('@/views/MarineSurveyDataView.vue')
  },
  {
    path: '/mechanical',
    name: 'mechanical',
    meta: {
      breadcrumbs: [{ displayName: 'Mechanical & Physical Data', displayLink: null }]
    },
    component: () => import('@/views/MechanicalPhysicalView.vue')
  },
  {
    path: '/spareparts',
    name: 'spareparts',
    meta: {
      breadcrumbs: [{ displayName: 'Spare Parts', displayLink: null }]
    },
    component: () => import('@/views/SparePartsView.vue')
  },
  {
    path: '/sync',
    name: 'sync',
    meta: {
      breadcrumbs: [{ displayName: 'Sync', displayLink: null }]
    },
    component: () => import('@/views/SyncView.vue')
  },
  {
    path: '/administration',
    component: () => import('@/views/AdminView.vue'),
    meta: {
      isAdminPage: true
    },
    children: [
      {
        path: 'profile',
        name: 'profile',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Profile Information', displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminProfileInformationView.vue')
      },
      {
        path: 'organisations',
        name: 'organisations',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Organisations', displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminOrganizationsView.vue')
      },
      {
        path: 'organisations/:id/:state',
        name: 'organisationDetails',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Organisations', displayLink: '/administration/organisations' },
            { displayName: null, displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminOrganizationDetailView.vue')
      },
      {
        path: 'projects',
        name: 'projects',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Project', displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminProjectsView.vue')
      },
      {
        path: 'projects/:id/:state',
        name: 'projectDetails',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Project', displayLink: '/administration/projects' },
            { displayName: null, displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminProjectDetailView.vue')
      },
      {
        path: 'alarm/configurations/',
        name: 'alarmConfigurations',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Alarms', displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminAlarmsView.vue')
      },
      {
        path: 'alarm/configurations/:id/:state',
        name: 'alarmConfigurationDetails',
        meta: {
          breadcrumbs: [
            { displayName: 'Administration', displayLink: null },
            { displayName: 'Alarms', displayLink: '/administration/alarm/configurations' },
            { displayName: null, displayLink: null }
          ]
        },
        component: () => import('@/views/admin/AdminAlarmDetailsView.vue')
      }
    ]
  }
]

const router = {
  history: createWebHistory(),
  routes: routes
}

export default createRouter(router)
